import Locale from '@serv/Locale'

export function _resolvePatientJourneyListColumnOfType_ipOpStatus(column, patientJourney, row) {
    if (!row[column.id] || !row[column.id].value) {
        return
    }

    column.cellText = Locale.getLanguageItemForModelEnumOrUndefined('ipOpStatus', row[column.id].value)
}
